/** Formal/title style: "M." / "Mme" */
export const GENDER_LABELS_TITLE: Record<string, string> = {
  FEMALE: 'Mme',
  MALE: 'M.',
}

/** Full descriptive style: "Homme" / "Femme" */
export const GENDER_LABELS_FULL: Record<string, string> = {
  FEMALE: 'Femme',
  MALE: 'Homme',
}
